
import type { PropType } from 'vue'
import { defineComponent } from 'vue'
import { UiTooltip } from '../../keen-ui'
import { EpbButton } from '../epb-button'

export default defineComponent({
  name: 'EpbModalDialog',
  components: {
    EpbButton,
    UiTooltip,
  },
  props: {
    closable: {
      default: true,
      type: Boolean,
    },
    width: {
      type: String,
      default: '720px',
    },
    height: {
      type: String,
      default: 'auto',
    },
    messages: {
      type: Object as PropType<{ actions: { close: string } }>,
      required: true,
    },
  },
  emits: {
    close: () => {},
  },
  setup() {
    return {
      baseClass: 'epb-modal-dialog',
    }
  },
})
